import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableBody, TableRow, TableCell, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import NoData from '../../Common/NoDataRow';
import { TooltipBottom } from "../../Common/CustomTooltips";

const useStyles = theme => ({
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    lastCell: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(1)
    },
    tooltipOffset: {
        marginTop: -theme.spacing(2)
    },
    tooltip: {
        fontSize: "0.8rem"
    }
});

const shortenEmails = (emails) => {
    if(!emails)
        return "b.d.";
    if(emails.length > 1)
        return emails[0] + "+" + (emails.length - 1).toString();
    return emails[0];
};

const getEmailsQuantity = (emails) => {
    if(!emails)
        return 0;
    return emails.length;
};

const showCorrectReportCycleName = (cycle) =>{
    if(cycle === 0)
        return "Miesięczny";
    if(cycle === 1)
        return "Tygodniowy";
    if(cycle === 2)
        return "Dobowy";
    return "";
};

const TableContent = props => {
    const { classes, reports, onManageOpen, onDelete } = props;

    const handleManageOpen = (id) => onManageOpen && onManageOpen(id);

    const handleDelete = (id) => onDelete && onDelete(id);

    const printTable = data => {
        if(!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={7} />;
        let i = 0;
        return data.map(row => {
            return (
                <TableRow
                    key={i++}
                    className={classes.row}
                >
                    <TableCell className={classes.cell}>
                        {i}.
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.nazwa}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.typ}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.nazwa_pliku}
                    </TableCell>
                    <TableCell  className={classes.cell}>
                        {showCorrectReportCycleName(row.cykl)}
                    </TableCell>
                        <TooltipBottom
                            title={row.email ? row.email.toString().replace(",", " ") : ""}
                            disableHoverListener={!(getEmailsQuantity(row.email) > 1)}
                            classes={{
                                tooltipPlacementBottom: classes.tooltipOffset,
                                tooltip: classes.tooltip
                            }}
                        >
                            <TableCell
                                className={classes.cell}
                                style={{cursor: (getEmailsQuantity(row.email) > 1) ? "pointer" : "inherit"}}
                            >
                                {shortenEmails(row.email)}
                            </TableCell>
                    </TooltipBottom>
                    <TableCell className={classes.lastCell}>
                        <IconButton onClick={handleManageOpen.bind(this, row.raport_id)}>
                            <ListIcon />
                        </IconButton>
                        <IconButton onClick={handleDelete.bind(this, row.raport_id)}>
                            <DeleteSweepIcon />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableBody>
            {printTable(reports)}
        </TableBody>
    );
};

TableContent.propTypes = {
    classes: PropTypes.object,
    reports: PropTypes.array,
    onManageOpen: PropTypes.func,
    onDelete: PropTypes.func
};

export default withStyles(useStyles)(TableContent);
